import { render, staticRenderFns } from "./Filtrate.vue?vue&type=template&id=12a0d383&scoped=true"
import script from "./Filtrate.vue?vue&type=script&lang=js"
export * from "./Filtrate.vue?vue&type=script&lang=js"
import style0 from "./Filtrate.vue?vue&type=style&index=0&id=12a0d383&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0d383",
  null
  
)

export default component.exports